/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import Box from "components/Atoms/Box";
import Input from "components/Atoms/Input/InputV1";
import Typography from "components/Atoms/Typography";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// Redux
import { useSelector } from "react-redux";
import { selectThemeMode } from "state/application/applicationSlice";

function InputPassword({ label, mt, mb, onChange }) {
  const { t } = useTranslation(["common", "auth"]);
  const [showPassword, setShowPassword] = useState(false);
  const themeMode = useSelector(selectThemeMode);
  const isDark = themeMode === "dark";

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box mt={mt} mb={mb}>
      <Box mb={1} ml={0.5} mt={0} lineHeight={0} display="inline-block">
        <Typography component="label" variant="caption" fontWeight="bold" textTransform="none">
          {label}
        </Typography>
      </Box>
      <Input
        type={showPassword ? "text" : "password"}
        onChange={onChange}
        placeholder={t("auth:login.password_label")}
        onWheel={(e) => e.target.blur()}
        sx={{
          paddingRight: "12px",
        }}
        endAdornment={
          <InputAdornment
            position="end"
            sx={{
              position: "absolute",
              right: "16px",
            }}
          >
            <IconButton
              aria-label={t("common:toggle_password_visibility")}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              sx={{
                color: isDark ? "#e5e7eb" : "#2d3748",
                padding: "4px",
                "&:hover": {
                  backgroundColor: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
            </IconButton>
          </InputAdornment>
        }
      />
    </Box>
  );
}

InputPassword.defaultProps = {
  mt: 0,
  mb: 1,
};

InputPassword.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  mt: PropTypes.number,
  mb: PropTypes.number,
};

export default InputPassword;
